(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("social-and-support-widget", [], factory);
	else if(typeof exports === 'object')
		exports["social-and-support-widget"] = factory();
	else
		root["social-and-support-widget"] = factory();
})(this, () => {
return 